export default {
  zh: {
    timeText: '时间',
    confirm: '确定',
    navTexg: '成员收到的硬币',
    time_filter: '时间筛选',
    time_filter_toast1: '结束时间不能早于开始时间'
  },
  en: {
    timeText: 'Time',
    confirm: 'Confirm',
    navTexg: 'Member received coins',
    time_filter: 'Time filter',
    time_filter_toast1: 'The end time cannot be earlier than the start time'
  },
  ar: {
    timeText: 'الوقت',
    confirm: 'نعم',
    navTexg: 'الكونزات التي حصل عليها الأعضاء',
    time_filter: 'فلتر الوقت',
    time_filter_toast1: 'لا يمكن أن يكون وقت الانتهاء أقدم من وقت البدء'
  },
  tr: {
    timeText: 'Zaman',
    confirm: 'Onayla',
    navTexg: 'Üye Altın Aldı',
    time_filter: 'Zaman filtresi',
    time_filter_toast1: 'Bitiş zamanı başlangıç zamanından önce olamaz'
  },
  uz: {
    timeText: 'Vaqt',
    confirm: 'Tasdiqlash',
    navTexg: "A'zo qabul qilgan tangalar",
    time_filter: 'Vaqt filtri',
    time_filter_toast1: "Oxirgi vaqt boshlanish vaqtidan oldin bo'lmasligi kerak"
  },
  ru: {
    timeText: 'Время',
    confirm: 'Подтвердить',
    navTexg: 'Члены получили монеты',
    time_filter: 'Фильтр по времени',
    time_filter_toast1: 'Время окончания не может быть раньше времени начала'
  },
  fa: {
    timeText: 'زمان',
    confirm: 'تأیید',
    navTexg: 'اعضا سکه دریافت کردند',
    time_filter: 'فیلتر زمانی',
    time_filter_toast1: 'زمان پایان نمی‌تواند زودتر از زمان شروع باشد'
  },
  pt: {
    timeText: 'Tempo',
    confirm: 'Confirmar',
    navTexg: 'Membro recebeu moedas',
    time_filter: 'Filtro de tempo',
    time_filter_toast1: 'O tempo final não pode ser anterior ao tempo de início'
  },
  id: {
    timeText: 'Waktu',
    confirm: 'Konfirmasi',
    navTexg: 'Anggota menerima koin',
    time_filter: 'Filter waktu',
    time_filter_toast1: 'Waktu akhir tidak boleh lebih awal dari waktu mulai'
  },
  ur: {
    timeText: 'وقت',
    confirm: 'تصدیق کریں',
    navTexg: 'رکن کے موصولہ سکے',
    time_filter: 'وقت کا فلٹر',
    time_filter_toast1: 'اختتامی وقت شروع کے وقت سے پہلے نہیں ہو سکتا'
  }
}



// WEBPACK FOOTER //
// src/pages/app/hobiMemberCoins/lang.js